// eslint-disable-next-line import/prefer-default-export
export enum DOWNLOAD_TYPE {
	DOWNLOAD_CHANGE = 'DOWNLOAD_CHANGE',
	DOWNLOAD_CLEAR = 'DOWNLOAD_CLEAR'
}
